var _excluded = ["svgRef", "title"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgMicrosoft = function SvgMicrosoft(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 17,
    viewBox: "0 0 17 17",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 1289"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Rectangle 286",
    style: {
      fill: "#f25022"
    },
    d: "M0 0h8v8H0z"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Rectangle 287",
    transform: "translate(0 9)",
    style: {
      fill: "#00a4ef"
    },
    d: "M0 0h8v8H0z"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Rectangle 288",
    transform: "translate(9)",
    style: {
      fill: "#7fba00"
    },
    d: "M0 0h8v8H0z"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Rectangle 289",
    transform: "translate(9 9)",
    style: {
      fill: "#ffb900"
    },
    d: "M0 0h8v8H0z"
  })));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgMicrosoft, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/microsoft.58be1d1b.svg";
export { ForwardRef as ReactComponent };